<img src="../../../../../assets/b2c/flight/create_booking.png" alt="" class="img-fluid">